const baseURL = 'https://217.77.13.31:8888';

export const createInquiry = async (inquiryData) => {
    const response = await fetch(`${baseURL}/create-inquiry`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(inquiryData),
    });
    console.log(JSON.stringify(response))
    if (response.ok) {
      const data = await response.json();
      return data;
    }
  };

export const getInquiries = async () => {
    const response = await fetch(`${baseURL}/get-inquiries`);
    if (response.ok) {
        const data = await response.json();
        return data;
    }
    throw new Error('Failed to fetch inquiries');
};